import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import type { Route } from 'nextjs-routes';
import type { Props } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

const Address = dynamic(() => import('ui/pages/Address'), { ssr: false });

const pathname: Route['pathname'] = '/address/[hash]';

const Page: NextPage<Props> = (props: Props) => {
  return (
    <PageNextJs pathname={ pathname } query={ props.query }>
      <Address/>
    </PageNextJs>
  );
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps';
